import React from 'react';
import { Button } from './ui/button';
import { Check, Star } from 'lucide-react';

const Packages = () => {
  const handleContact = () => {
    window.open('https://t.me/darkerthandeath', '_blank');
  };

  const packages = [
    {
      name: 'Starter',
      price: 'SGD 7500',
      description: 'Perfect for MVPs, proof-of-concepts, and small-scale projects. Fast turnaround with focused scope.',
      features: [
        'Smart contract development',
        'Basic UI/UX design',
        'Security audit',
        '2-4 week delivery',
        'Post-launch support (30 days)'
      ],
      gradient: 'from-[#00d4ff] to-[#0ea5e9]',
      popular: false
    },
    {
      name: 'Growth',
      price: 'Custom',
      description: 'Tailored solutions for growing projects. Full-stack development with ongoing iterations and feature additions.',
      features: [
        'End-to-end product development',
        'Custom architecture & design',
        'Smart contracts + AI/ML integration',
        'Comprehensive testing & audits',
        'Flexible timeline',
        'Dedicated team',
        'Priority support'
      ],
      gradient: 'from-[#ff6b35] to-[#ff2e63]',
      popular: true
    },
    {
      name: 'Enterprise',
      price: 'Partnership',
      description: 'Long-term strategic partnership for ambitious products. Co-build, scale, and grow together with shared vision.',
      features: [
        'Co-ownership opportunities',
        'Full product lifecycle management',
        'Scalable infrastructure',
        'Continuous optimization',
        'Token & equity arrangements',
        'White-glove service',
        '24/7 support'
      ],
      gradient: 'from-[#a855f7] to-[#ec4899]',
      popular: false
    }
  ];

  return (
    <section id="pricing" className="py-24 bg-[#0a0e1a] relative">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4">
            Packages
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Choose a fast, well-scoped engagement or a full partnership for product co-build.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {packages.map((pkg, index) => (
            <div
              key={index}
              className={`relative bg-gradient-to-br from-[#1a1f35] to-[#0f1420] rounded-2xl border overflow-hidden transition-all duration-500 hover:transform hover:scale-[1.02] ${
                pkg.popular
                  ? 'border-[#ff6b35] shadow-2xl shadow-[#ff6b35]/20'
                  : 'border-white/10 hover:border-white/30'
              }`}
            >
              {/* Popular Badge */}
              {pkg.popular && (
                <div className="absolute top-0 right-0 bg-gradient-to-r from-[#ff6b35] to-[#ff2e63] text-white px-4 py-1 rounded-bl-xl flex items-center gap-1">
                  <Star size={14} fill="white" />
                  <span className="text-xs font-bold">POPULAR</span>
                </div>
              )}

              <div className="p-8 space-y-6">
                {/* Package Name */}
                <div>
                  <h3 className="text-2xl font-bold text-white mb-2">{pkg.name}</h3>
                  <div className={`text-4xl font-bold bg-gradient-to-r ${pkg.gradient} bg-clip-text text-transparent`}>
                    {pkg.price}
                  </div>
                </div>

                {/* Description */}
                <p className="text-gray-400 leading-relaxed">{pkg.description}</p>

                {/* Features */}
                <div className="space-y-3 pt-4">
                  {pkg.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className="flex items-start gap-3">
                      <Check size={20} className={`text-[#ff6b35] mt-0.5 flex-shrink-0`} />
                      <span className="text-gray-300">{feature}</span>
                    </div>
                  ))}
                </div>

                {/* CTA Button */}
                <Button
                  onClick={handleContact}
                  className={`w-full bg-gradient-to-r ${pkg.gradient} hover:opacity-90 text-white py-3 rounded-lg transition-all duration-300 mt-6`}
                >
                  Talk to an Expert
                </Button>
              </div>

              {/* Decorative Gradient */}
              <div className={`absolute inset-0 bg-gradient-to-t ${pkg.gradient} opacity-0 hover:opacity-5 transition-opacity duration-500 pointer-events-none`}></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Packages;